export default __webpack_public_path__ + "2448a68c856d0037dc9714a7b6bc2fa5.png";